import { combineReducers } from 'redux'
import { 
    MAINTENANCE_MODAL, MAINTENANCE_GET_SUCCESS,
    ADD_MAINTENANCE_GET_SUCCESS, DELETE_MAINTENANCE_GET_SUCCESS,
    EDIT_MAINTENANCE_GET_SUCCESS, MAINTENANCE_MODAL_PAGE
} from '../actions/constant'

const modal = (state = false, action) => {
    switch (action.type) {
      case MAINTENANCE_MODAL:
        return action.val
      default:
        return state
    }
}

const maintenancePageData = (state = {maintenance:false, loginStat:false, role:''} , action) => {
  switch(action.type){
    case MAINTENANCE_MODAL_PAGE:
      return action.val
    default:
      return state
  }
}

const maintenanceEditData = (state = {data:{status:0}, isLoad:false}, action) => {
  switch (action.type){
    case EDIT_MAINTENANCE_GET_SUCCESS:
      return {data:action.val, isLoad:action.load}
    default:
      return state
  }
}

const maintenanceDeleteData = (state = {data:{status:0}, isLoad:false}, action) => {
  switch (action.type){
    case DELETE_MAINTENANCE_GET_SUCCESS:
      return {data:action.val, isLoad:action.load}
    default:
      return state
  }
}

const maintenanceAddData = (state = {data:{status:0}, isLoad:false}, action) => {
    switch (action.type){
      case ADD_MAINTENANCE_GET_SUCCESS:
        return {data:action.val, isLoad:action.load}
      default:
        return state
    }
  }

const maintenanceGetAllData = (state = {data:[], isLoad:false}, action) => {
    switch (action.type){
      case MAINTENANCE_GET_SUCCESS:
        return {data:action.val, isLoad:action.load}
      default:
        return state
    }
  }

const maintenanceReducer = combineReducers({
    modal,
    maintenanceGetAllData,
    maintenanceAddData,
    maintenanceDeleteData,
    maintenanceEditData,
    maintenancePageData
  })
  
  export default maintenanceReducer